import { useQuery } from '@tanstack/react-query';
import { api } from './api';

/** Where new organisations get in touch while EducAitor sets organisations up itself. */
export const CONTACT_URL = 'https://educaitor.ai/contact-us/';

/**
 * Whether anyone can create an organisation by signing up. Off (the default,
 * and while loading): EducAitor sets organisations up and invites their owner.
 */
export function useSelfServe(): boolean {
  const q = useQuery({
    queryKey: ['signup-options'],
    queryFn: () => api<{ selfServe: boolean }>('/auth/signup-options'),
    staleTime: 10 * 60_000,
    retry: false,
  });
  return q.data?.selfServe === true;
}
